var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{attrs:{"dense":"","headers":_vm.headers,"items":_vm.productosTabla,"item-key":"Referencia","hide-default-footer":true},scopedSlots:_vm._u([{key:"item.actions",fn:function({ item }){return [_c('v-icon',{attrs:{"size":"16"},on:{"click":function($event){return _vm.deleteItem(item)}}},[_vm._v(" $fi-trash-2 ")])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }